import "./Us.css";
import { FaShieldAlt, FaClock, FaUserCheck, FaMapMarkerAlt } from "react-icons/fa";

export default function Us() {
  return (
    <section id="Us" className="section us-section">
      <div className="us-grid">
        {/* Colonne gauche : Mission & Valeurs */}
        <div className="us-content">
          <span className="section-tag">{"//"} NOTRE IDENTITÉ & DÉONTOLOGIE</span>
          <h2 className="section-title">
            Partenaire de Confiance pour la <span className="text-gold">Sécurité de vos Biens</span>
          </h2>

          <p className="us-lead">
            <strong>Wourou – Surveillance • Protection • Sécurité (WSPS)</strong> est une société de sécurité
            privée agréée par le CNAPS, intervenant auprès des entreprises, collectivités, chantiers BTP et particuliers
            sur l’ensemble de l’Île-de-France.
          </p>

          <p className="us-description">
            Notre offre globale de sûreté combine rondes de prévention, interventions sur alarme, surveillance
            statique ou mobile, encadrement d'événements et sécurité incendie (SSIAP). Nous mettons un point d'honneur
            à assurer une formation continue rigoureuse de nos agents afin de garantir ponctualité, fermeté et courtoisie
            en toute circonstance.
          </p>

          <div className="us-values">
            <div className="value-badge">
              <FaUserCheck className="value-icon" />
              <span>Agents Qualifiés & Contrôlés</span>
            </div>
            <div className="value-badge">
              <FaClock className="value-icon" />
              <span>Disponibilité 24/7/365</span>
            </div>
            <div className="value-badge">
              <FaShieldAlt className="value-icon" />
              <span>Cadre Légal & Éthique CSI</span>
            </div>
          </div>
        </div>

        {/* Colonne droite : Carte d'identité WSPS */}
        <div className="us-corporate-card">
          <div className="corporate-card-glow"></div>
          <div className="corporate-logo-wrap">
            <img
              src="/logo.png"
              alt="Logo WSPS - Wourou Surveillance Protection Sécurité"
              className="corporate-logo"
            />
          </div>

          <div className="corporate-details">
            <div className="detail-row">
              <span className="detail-label">Raison Sociale</span>
              <span className="detail-val">WSPS - Wourou Sécurité</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Agrément CNAPS</span>
              <span className="detail-val text-gold">N° AUT-078-2124-07-22-20250989623</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Implantation</span>
              <span className="detail-val">
                <FaMapMarkerAlt className="mini-pin" /> 78180 Montigny-le-Bretonneux
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Zone d'intervention</span>
              <span className="detail-val">Paris & Région Île-de-France (8 dépt.)</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">SIREN / RCS</span>
              <span className="detail-val">945 173 516 • Versailles</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
